import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=f364dd50&scoped=true&"
import script from "./CompanyList.vue?vue&type=script&lang=js&"
export * from "./CompanyList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=f364dd50&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f364dd50",
  null
  
)

export default component.exports